module.exports = __webpack_public_path__ + "img/Group54.7c48dcb4.png";